import React from 'react';
import pikkocoin from '../../styles/img/Pikkocoin.svg';
import {
  formatFidelityPoints,
  formatFidelityPointsFromUser,
} from '../../utils/StringUtils';
import numberRollup from 'number-rollup';
import { useEffect, useRef } from 'react';

const FidelityCard = ({ user, earnPoints, animation }) => {
  const fidelityRef = useRef(null);

  useEffect(() => {
    if (user && user._id && user._id.length > 0 && !animation) {
      const earnPoint = formatFidelityPoints(earnPoints);
      if (fidelityRef.current) {
        setTimeout(() => {
          if (fidelityRef.current && document.getElementById('fidelity')) {
            try {
              numberRollup({
                id: 'fidelity',
                startNumber: 0,
                endNumber: earnPoint,
                duration: 600,
              });
            } catch (error) {
              console.error('Error in numberRollup animation:', error);
            }
          }
        }, 1000);
      }
    }
  }, [user, earnPoints, animation]);
  if (!user || !user._id) {
    return <></>;
  }

  const fidelityPoints = formatFidelityPointsFromUser(user);
  const showFidelityPoints = fidelityPoints > 0;

  return (
    <div className="white_card">
      <div className="card_text">
        <p className="text-3xl font-bold">
          {showFidelityPoints
            ? 'Points PikkoPay'
            : 'Tu as terminé ta commande.'}
        </p>
        <p className="second_text">Fidélité PikkoPay</p>
      </div>
      {showFidelityPoints && (
        <div
          style={{
            fontFamily: 'geomanistmedium',
            maxWidth: '170px',
            textAlign: 'center',
            fontSize: '40px',
            fontWeight: 'bold',
            display: 'flex',
            gap: '0.2em',
          }}
        >
          <img className="coin" src={pikkocoin} alt="coin" />
          {!animation && !!earnPoints && (
            <div id="fidelity" ref={fidelityRef}>{formatFidelityPoints(earnPoints)}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default FidelityCard;
